import React from "react";

// Styles
import AsiaPlViewContainer from "./AsiaPlView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface GEFSectorsViewProps {}

const GEFSectorsView = ({}: GEFSectorsViewProps) => {
    return (
        <AsiaPlViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="5addf6ab-5002-4a02-9003-d42ab221644f"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </AsiaPlViewContainer>
    );
};
export default GEFSectorsView;
